import React from 'react'
import styles from './AvatarImage.module.scss'
import cl from 'classnames'

const defaultImage = 'https://www.securities-services.societegenerale.com/uploads/tx_bisgbio/default-profile.png'

interface Props {
  size?: number
  src?: string
  alt?: string
  className?: string
}

const AvatarImage = (props: Props) => {
  const {
    size = 20,
    src,
    alt,
    className
  } = props

  return (
    <figure
      className={cl(styles.figure, className)}
      style={{
        width: size,
        height: size
        // backgroundImage: `url(${src || defaultImage})`
      }}
      title={alt}
    >
      <img
        src={src || defaultImage}
        alt={alt}
      />
      {/* <div
        className={cl(styles.figure, className)}
        style={{
          width: size,
          height: size,
          backgroundImage: `url(${src || defaultImage})`
        }}
        title={alt}
      /> */}
    </figure>
  )
}

export default AvatarImage
